module.exports = __webpack_public_path__ + "img/stackslash-38.ef67311e.jpg";